<template>
  <f7-page>
    <div>
      <f7-navbar
        sliding
        :style="appTheme"
      >
        <f7-nav-left name="frmRecuperarMercanciaVolcadaVistaPartida-nav-lefth">
          <f7-link @click="NavigateBack()">
            <img
              alt="iconBack"
              src="@/static/icons/back.svg"
            >
          </f7-link>
        </f7-nav-left>
        <f7-nav-title>
          {{ $t('production.dump.retrieve.batchDetails.title') }}
        </f7-nav-title>
      </f7-navbar>
      <PCInformacionLineaPunto class="navbar-amarillo-1" />

      <div class="div-001">
        <PCRecuperarMercanciavolcadaVistaPartida :id-partida="partidaActiva.Id" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import PCInformacionLineaPunto from '@/components/production/traceability/PCInformacionLineaPunto.vue';
import PCRecuperarMercanciavolcadaVistaPartida from '@/components/production/traceability/PCRecuperarMercanciaVolcadaVistaPartida.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmRetrieveOverturnedMerchandiseSplitView',
  components: {
    PCInformacionLineaPunto,
    PCRecuperarMercanciavolcadaVistaPartida,
  },

  data() {
    return {
      partidaActiva: '',
    };
  },
  computed: {
    ...mapWritableState(useTraceabilityStore, ['partidaSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-orange)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  created() {
    this.ActivarListener();
    this.partidaActiva = this.partidaSeleccionada;
  },
  beforeUnmount() {
    this.DesactivarListener();
    this.partidaSeleccionada = null; // Eliminamos la partida seleccionada.
  },
  methods: {
    NavigateBack() {
      f7.views.main.router.back();
    },
    ActivarListener() {
      Log(this, this.ActivarListener.name);
      // EventBus para ser llamados desde otros Componentes.
      eventBus.on('PCRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado', () => {
        this.MovimientoRealizado();
      });
    },
    DesactivarListener() {
      Log(this, this.DesactivarListener.name);
      eventBus.off('PCRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado');
    },

    VerDetalleVolcado(idVolcado) {
      Log(this, this.VerDetalleVolcado.name);
      this.actionsSeleccionRecuperado = true;
      [this.seleccionVolcado] = this.volcados.filter((v) => v.Id === idVolcado);
      Log(this.seleccionVolcado);
    },
    /** Método MovimientoRealizado */
    MovimientoRealizado() {
      Log(this, this.MovimientoRealizado.name);
      eventBus.emit('movimientoRealizado'); // Llama al resto de componentes para su actualización.
      eventBus.emit('frmRecuperarMercanciaVolcadaVistaPartida_movimientoRealizado'); // Llama al resto de componentes para su actualización.
      f7.views.main.router.back();
    },
  },
};
</script>

<style scoped lang="scss">
.div-horaRegistroMovimiento {
  border: 1px solid #009ba6;
  background: rgb(0 155 166 / 10%);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #009ba6;
  font-size: 3.5vw;
  min-height: 25px;
  max-width: 100px;
}

.span-numeroPartida {
  color: var(--his-darkgray);
  font-size: 5vw;
}

.div-contenidofrmRecuperarMercanciaVolcadaVistaPartida {
  margin: 20px;
}

.span-ttlElemento {
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
}

.span-textoElemento {
  color: #009ba6;
  font-size: 14px;
  font-weight: 500;
}

.div-informacionDelDetalle {
  margin-top: 21px;
}

.row {
  padding-bottom: 15px;
}

.navbar-amarillo-1 {
  background-color: var(--his-orange);
}
</style>
